import { Ad } from './Ad';

export class Playlist {
    public ads: Ad[] = [];
    public adInterestsEnabled?: boolean;
}
